import React, { useState } from 'react';
import StepWrapper from '../stepWrapper';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { RadioButtonGroup, Box } from 'grommet';
import styled from 'styled-components';
import {
  setTab,
  OrderFlowTabs,
  setHealthCard,
  setLegalConsentOne,
  setNewsConsent
} from '../../../redux/orderFlow/orderFlowSlice';
import { useTranslation } from 'react-i18next';
import { navigateToNextTab } from '../../../utils/navigation-helpers';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const HealthCard = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const options = [
    { label: t('checkbox-healthInsuranceTrue'), value: true },
    { label: t('checkbox-healthInsuranceFalse'), value: false }
  ];
  const [value, setValue] = useState<boolean>(
    useAppSelector(state => state.orderFlow.withEHIC)
  );

  const productsResponse = useSelector(
    (state: RootState) => state.products.products.response
  );
  const products = Array.isArray(productsResponse) ? productsResponse : [];
  const mainProduct =
    products.length > 0
      ? products.find(product => product.productId === 'MAIN2024')
      : null;
  const priceWithEHIC = mainProduct?.priceWithEHIC;
  const priceWithoutEHIC = mainProduct?.priceWithoutEHIC;

  const handleContinue = () => {
    if (value !== undefined) {
      dispatch(setHealthCard({ withEHIC: value }));
      navigateToNextTab(dispatch, OrderFlowTabs.ExtendedInsurance);
    }
  };
  const handleBack = () => {
    dispatch(setLegalConsentOne({ legalConsentOne: false }));
    dispatch(setNewsConsent({ newsConsent: false }));
    navigateToNextTab(dispatch, OrderFlowTabs.PersonalDetailsConfirmation);
  };
  return (
    <StepWrapper
      next={{ f: handleContinue, label: 'NEXT' }}
      back={{ f: handleBack, label: 'BACK' }}
    >
      <Box align='center'>
        <Box align='left'>
          <p style={{ color: 'white', lineHeight: '1.5' }}>
            {t('form-sub-tab-4')}
          </p>
          <RadioButtonGroupStyled
            name='doc'
            options={options}
            value={value}
            onChange={(event: any) => setValue(event.target.value === 'true')}
            align='left'
          />
          <p style={{ color: 'white', lineHeight: '1.5' }}>
            {value
              ? t('form-sub-true-tab-4').replace(
                  'PRICE',
                  priceWithEHIC?.toString() || ''
                )
              : t('form-sub-false-tab-4').replace(
                  'PRICE',
                  priceWithoutEHIC?.toString() || ''
                )}
          </p>
        </Box>
      </Box>
    </StepWrapper>
  );
};

export default HealthCard;

const RadioButtonGroupStyled = styled(RadioButtonGroup)`
  color: white;
  align-items: left;
  svg {
    fill: #06b192;
  }
  div {
    div {
      box-sizing: border-box;
      border-radius: 100%;
      border: 1px solid white;
    }
  }
`;
